import React, { Component } from 'react'
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { MDBDataTable, MDBCol, MDBTableBody, MDBTableHead } from 'mdbreact';


import Notiflix from "notiflix";
import PostApiCall from "../../Api";

import moment from 'moment';




import DateTimePicker from 'react-datetime-picker';

class cutomerList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      allDetails: [],
      // isdeleted: false,
      searchInput: '',
      DaysData: [{ label: 'Last 3 Days', value: '3' },
      { label: 'Last 7 Days', value: '7' },
      { label: 'This Month', value: '31' },

      ],
      Month: null,
      // Year:null,

      FromDate: null,
      ToDates: null



    };
  }


  componentDidMount() {
    var login = localStorage.getItem("LoginDetail");
        var details = JSON.parse(login);
        // console.log(details[0])
        this.setState({
          Usertype: details[0].fld_usertype,
        });
        console.log("this.state.Usertype  " + this.state.Usertype )
        if (details[0].fld_usertype != "Admin")
        {
          window.location.href = "/"
          }
    Notiflix.Loading.Init({
      svgColor: 'rgb(171, 61, 0)'

    });





    // Notiflix.Loading.Dots('');

    // GetApiCall.getRequest("Get_TransactionReport").then(resultdes =>
    //     resultdes.json().then(obj => {
    //         // console.log(obj.data)
    //         this.setState({
    //             allDetails: obj.data
    //         })


    //         Notiflix.Loading.Remove();
    //     }))

  }


  SearchData() {
    if (this.state.Month !== null || this.state.FromDate !== null || this.state.ToDates !== null) {
      Notiflix.Loading.Dots('Please wait...');

      PostApiCall.postRequest({
        selectfor: this.state.Month,
        fromdate: this.state.FromDate === null ? null : moment(this.state.FromDate).format('YYYY-MM-DD') + ' ' + '00:00',
        todate: this.state.ToDates === null ? null : moment(this.state.ToDates).format('YYYY-MM-DD') + ' ' + '00:00',

      }, "Get_TransactionReport").then((resultcategory =>
        resultcategory.json().then(obj2 => {

          if (resultcategory.status === 200 || resultcategory.status === 201) {
            // console.log(obj2.data)
            this.setState({
              ...this.state,
              allDetails: obj2.data
            });


            Notiflix.Loading.Remove()


          }
          else {
            Notiflix.Loading.Remove();
            Notiflix.Notify.Failure(obj2.data);
          }


        }

        )
      ))
    }
    else {
      Notiflix.Notify.Failure('Please select atleast one search criteria');
    }

  }








  seachBarHandler = (e) => {
    this.setState({ ...this.state, searchInput: e.target.value })
  }
  render() {


    // const data = {
    //   columns: [
    //     {
    //       label: 'S.No.',
    //       field: 'serial',
    //       sort: 'disabled',
    //       width: 150
    //     },
    //     {
    //       label: "Customer Book Number",
    //       field: "accountNumber",
    //       sort: "disabled",
    //       width: 270
    //     },
    //     {
    //       label: "Name",
    //       field: "name",
    //       sort: "disabled",
    //       width: 270
    //     },
    //     {
    //       label: "Email",
    //       field: "email",
    //       sort: "disabled",
    //       width: 270
    //     },
    //     {
    //       label: "Transaction ID",
    //       field: "transaction",
    //       sort: "disabled",
    //       width: 200
    //     },





    //     {
    //       label: "Paid Amount",
    //       field: "paidAmount",
    //       sort: "disabled",
    //       width: 100
    //     },


    //     {
    //       label: "Paid Date",
    //       field: "paid",
    //       sort: "disabled",
    //       width: 150
    //     },


    //     // {
    //     //   label: "Paid Month",
    //     //   field: "month",
    //     //   sort: "disabled",
    //     //   width: 150
    //     // },
    //     {
    //       label: "Status",
    //       field: "status",
    //       sort: "disabled",
    //       width: 150
    //     },


    //   ],
    //   rows:
    //     this.state.allDetails && this.state.allDetails.filter(data => {

    //       let name = data.fld_name !== null ? [...data.fld_name.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""
    //       let accn = data.fld_accountno !== null ? [...data.fld_accountno.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""
    //       let mob = data.fld_mobile !== null ? [...data.fld_mobile.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""
    //       let paidtime = data.TIME !== null ? [...data.TIME.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""


    //       if (this.state.searchInput.length > 0 && name[0]) {

    //         return data
    //       }

    //       if (this.state.searchInput.length > 0 && accn[0]) {
    //         return data
    //       }
    //       if (this.state.searchInput.length > 0 && mob[0]) {
    //         return data
    //       }


    //       if (this.state.searchInput.length > 0 && paidtime[0]) {
    //         return data
    //       }



    //       if (this.state.searchInput.length == 0) {
    //         return data
    //       }

    //     }).map((data, i) => {
    //       //  console.log(data)
    //       return {
    //         serial: <td className="text-center">{(i + 1)}</td>,
    //         name: <td style={{ textAlign: 'left' }}>{data.fld_name}</td>,
    //         email: <td style={{ textAlign: 'left' }}>{data.fld_email}</td>,
    //         // mobile: <td style={{textAlign:'left'}}>{data.fld_mobile}</td>,
    //         accountNumber: <td style={{ textAlign: 'left' }}>{data.fld_accountno}</td>,
    //         // scheme: <td style={{textAlign:'left'}}>{data.fld_chitschema}</td>,
    //         transaction: <td style={{ textAlign: 'left' }}>{data.transid}</td>,
    //         paidAmount: <td style={{ textAlign: 'left' }}>{data.paidamount}</td>,
    //         paid: <td style={{ textAlign: 'left' }}>{data.fld_paiddate}</td>,


    //         // month: <td style={{textAlign:'left'}}>{data.month}</td>,
    //         status: <td style={{ textAlign: 'left' }}>{data.status}</td>





    //       }
    //     })
    // };





    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>


            {/* Render Breadcrumb */}
            <Breadcrumbs title={'Report'} breadcrumbItem={'Transactions Report'} />

            <Row>
              <Col xl="12">

                <Card className="overflow-hidden">
                  <div className="maxXchange-bg-soft-pink" style={{ background: 'rgb(171, 61, 0)' }}>
                    <Row>


                      <Col xs="6">
                        <div className="maxXchange-text p-3"><h5 className="maxXchange-text">Report </h5>

                        </div>
                      </Col>


                    </Row>
                    <Row>

                    </Row>
                  </div>

                  <Card className="overflow-hidden">
                    <div className="maxXchange-bg-soft-pink" style={{ background: '#dfb65c' }}>
                      <Row>


                        <Col xs="6">
                          <div className="maxXchange-text p-3">
                            <h5 className="maxXchange-text">Transactions Report</h5>

                          </div>
                        </Col>


                      </Row>
                    </div>


                    <Card>
                      <CardBody>
                        <div className="row my-1">

                          <div className="col-2">
                            <label>Select For</label>
                            <div className="form-group">
                              <select className="form-control" value={this.state.Month}
                                onChange={(text) => {
                                  this.setState({
                                    Month: text.target.value
                                  })

                                }}>
                                <option value="">Select For</option>
                                {this.state.DaysData.map((data) => {
                                  return (
                                    <option
                                      key={data.label}

                                      value={data.value}
                                    >
                                      {data.label}
                                    </option>
                                  );
                                })}

                              </select>


                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label>From Date</label>
                              <input className="form-control"
                                type="date" value={this.state.FromDate} placeholder='Select From Date'
                                onChange={(time) => {
                                  this.setState({
                                    FromDate: time.target.value
                                  })
                                  // console.log(time.target.value)
                                }} />
                            </div>
                          </div>

                          <div className="col-3">
                            <div className="form-group">
                              <label>To Date</label>
                              <input className="form-control"
                                type="date" value={this.state.ToDates}
                                placeholder='select to date'
                                onChange={(time) => {
                                  this.setState({
                                    ToDates: time.target.value
                                  })
                                }} />
                            </div>
                          </div>






                          <div className="col-2">
                            <div className="position-relative">
                              <a onClick={this.SearchData.bind(this)}
                                className={'btn'}
                                style={{ backgroundColor: '#880105', color: '#e1b761', marginTop: '13%' }}>
                                Search <i className="fa fa-search" aria-hidden="true"></i>
                              </a>

                            </div>

                          </div>

                        </div>


                      </CardBody>{" "}

                    </Card>
                    <CardBody className="pt-0">
                      <Row>
                        <MDBCol md="3" style={{ marginBottom: '10px', marginTop: '10px' }}>

                          <input className="form-control" type="text" placeholder="Search" aria-label="Search" onChange={(e) => this.seachBarHandler(e)} value={this.state.searchInput} />
                        </MDBCol>

                        <Col md="12" >
                          <div class="table-responsive">
                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th>S.No.</th>
                                  <th>Customer Book Number</th>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <th>Transaction ID</th>
                                  <th>Paid Amount</th>
                                  <th>Paid Date</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.allDetails && this.state.allDetails.filter(data => {

                                  let name = data.fld_name !== null ? [...data.fld_name.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""
                                  let accn = data.fld_accountno !== null ? [...data.fld_accountno.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""
                                  let mob = data.fld_mobile !== null ? [...data.fld_mobile.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""
                                  let paidtime = data.TIME !== null ? [...data.TIME.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""

                                  let email = data.fld_email !== null ? [...data.fld_email.toLowerCase().matchAll(this.state.searchInput.toLowerCase())] : ""

                                  if (this.state.searchInput.length > 0 && name[0]) {

                                    return data
                                  }

                                  if (this.state.searchInput.length > 0 && accn[0]) {
                                    return data
                                  }
                                  if (this.state.searchInput.length > 0 && mob[0]) {
                                    return data
                                  }


                                  if (this.state.searchInput.length > 0 && paidtime[0]) {
                                    return data
                                  }
                                  if (this.state.searchInput.length > 0 && email[0]) {
                                    return data
                                  }



                                  if (this.state.searchInput.length == 0) {
                                    return data
                                  }

                                }).map((data, i) => {
                                  //  console.log(data)
                                  return (
                                    <tr>
                                      <td className="text-center">{(i + 1)}</td>
                                      <td style={{ textAlign: 'left' }}>{data.fld_accountno}</td>

                                      <td style={{ textAlign: 'left' }}>{data.fld_name}</td>
                                      <td style={{ textAlign: 'left' }}>{data.fld_email}</td>
                                      {/* // mobile: <td style={{textAlign:'left'}}>{data.fld_mobile}</td> */}
                                      {/* // scheme: <td style={{textAlign:'left'}}>{data.fld_chitschema}</td> */}
                                      <td style={{ textAlign: 'left' }}>{data.transid}</td>
                                      <td style={{ textAlign: 'left' }}>{data.paidamount}</td>
                                      <td style={{ textAlign: 'left' }}>{data.fld_paiddate}</td>


                                      {/* // month: <td style={{textAlign:'left'}}>{data.month}</td>, */}
                                      <td style={{ textAlign: 'left' }}>{data.status}</td>


                                    </tr>

                                  )
                                })
                                }


                              </tbody>
                            </table>
                          </div>

                        </Col>

                      </Row>
                    </CardBody>
                  </Card>


                  {/* <WelcomeComp /> */}


                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }

  newMethod() {
    return moment(this.state.ToDates).format('YYYY-MM-DD HH:mm');
  }
}
export default cutomerList